import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import util from '../../common/util';

@Component
export default class NavMenuComponent extends Vue {
    menuIndex: string = '';
    accountType: string = '';

    handleOpen(a, b, c) {
    };
    handleClose(a, b, c) {
    };
    handleSelect(url) {
        //更新路由状态信息
        this.$store.commit({
            type: 'changeMenuIndex',
            currentMenuIndex: url,
        });
        this.toUrl('/' + url, {});
    };

    computed() {
        
    }

    //跳转
    toUrl(path, opt) {
        this.$router.push({
            path: path,
        });
    }

    @Watch('$store.state.accountType', { deep: true })
    watchCount(newVal, oldVal) {
        this.accountType = this.$store.state.accountType;
    }
    
    mounted() {
        this.accountType = this.$store.state.accountType;
        this.menuIndex = this.$store.state.menuIndex;
    }
}
